import { render, staticRenderFns } from "./Test2.vue?vue&type=template&id=1edd66c3&scoped=true&"
import script from "./Test2.vue?vue&type=script&lang=js&"
export * from "./Test2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edd66c3",
  null
  
)

export default component.exports